import script from "./CustomerIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerIndex.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__